"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_1 = require("redux-persist/integration/react");
var immutable_1 = require("connected-react-router/immutable");
var store_1 = __importStar(require("./store/store"));
var react_router_dom_1 = require("react-router-dom");
var Sentry = __importStar(require("@sentry/react"));
var tracing_1 = require("@sentry/tracing");
var react_i18next_1 = require("react-i18next");
var actions_1 = require("./store/app/actions");
var actions_2 = require("./store/auth/actions");
var pages_1 = require("./pages");
var react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
var ScrollToTop_1 = __importDefault(require("./components/ScrollToTop"));
var i18n_1 = __importDefault(require("./lang/i18n"));
require("./main.scss");
var react_query_1 = require("@tanstack/react-query");
var react_query_devtools_1 = require("@tanstack/react-query-devtools");
var Catalog_1 = require("./pages/Catalog");
var ConfirmDone_1 = require("./pages/Confirm/ConfirmDone");
var _a = (0, store_1.default)({}), store = _a.store, persistor = _a.persistor;
Sentry.init({
    dsn: "https://ad56883581714d97b7fbec4c032b93a8@o559475.ingest.sentry.io/5769195",
    integrations: [new tracing_1.Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: "development",
});
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
window.addEventListener('resize', function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
});
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: Infinity,
            retry: 0,
            refetchOnWindowFocus: false
        },
    },
});
var menuRoot = document.getElementById('app');
if (menuRoot) {
    var id = Number(menuRoot === null || menuRoot === void 0 ? void 0 : menuRoot.dataset.id);
    var domain = menuRoot.dataset.domain || '';
    store.dispatch((0, actions_1.setAppId)(id));
    store.dispatch((0, actions_1.setDomain)(domain));
    store.dispatch((0, actions_1.fetchAppRequest)());
    store.dispatch((0, actions_2.fetchUserRequest)());
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(react_redux_1.Provider, __assign({ store: store }, { children: (0, jsx_runtime_1.jsx)(react_1.PersistGate, __assign({ loading: null, persistor: persistor }, { children: (0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, __assign({ client: queryClient }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, __assign({ i18n: i18n_1.default }, { children: (0, jsx_runtime_1.jsxs)(immutable_1.ConnectedRouter, __assign({ history: store_1.history }, { children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.Router, __assign({ history: store_1.history }, { children: [(0, jsx_runtime_1.jsx)(ScrollToTop_1.default, {}), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/store", component: pages_1.Main }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/contacts', component: pages_1.Contacts }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant', component: Catalog_1.CatalogPage }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/checkout', component: pages_1.Checkout }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/login', component: pages_1.Login }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/profile', component: pages_1.Profile }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/confirm', component: pages_1.Confirm }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/confirm/done', component: ConfirmDone_1.ConfirmDone }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/orders', component: pages_1.Orders }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/contacts', component: pages_1.Contacts }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/payments', component: pages_1.Payments }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/privacy', component: pages_1.Privacy }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/store/:restaurant/terms', component: pages_1.Terms })] })] })), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, {}), (0, jsx_runtime_1.jsx)(react_query_devtools_1.ReactQueryDevtools, { position: "bottom-right" })] })) })) })) })) })), menuRoot);
}
